import { Typography } from "@material-tailwind/react";
import React from "react";
import Alert from "@/components/Elements/Alert";
import classNames from "classnames";
import "moment/locale/sv";

const NotificationTitle = ({ type }: { type: string }) => {
  let text = "";

  switch (type) {
    case "invoices":
      text = "Betalningspåminnelse";
      break;

    default:
      text = "Notifikation";
  }

  return (
    <h3 className="font-semibold text-16 font-bold inline-block">{text}</h3>
  );
};

const Wrapper = ({ children, notification, matchOnEndpoint, onClick }: any) => {
  const notificationTheme = notification?.theme || "yellow";

  const alertClass = classNames({
    "bg-palegoldenrod text-black/80": notificationTheme === "yellow",
    "bg-white text-blue": notificationTheme === "white",

    "!opacity-100 cursor-pointer hover:bg-opacity-90 transition-all duration-500":
      matchOnEndpoint,
  });

  return (
    <div onClick={onClick}>
      <Alert
        key={notification?.id}
        className={alertClass}
        animate={{
          mount: { opacity: 1, transform: "none" },
          unmount: { opacity: 1, transform: "none" },
        }}
        icon={
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="h-6 w-6"
          >
            <path
              fillRule="evenodd"
              d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 01.67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 11-.671-1.34l.041-.022zM12 9a.75.75 0 100-1.5.75.75 0 000 1.5z"
              clipRule="evenodd"
            />
          </svg>
        }
      >
        <div className="flex flex-col">
          <NotificationTitle type={notification?.type} />
          <span className="font-normal">{children}</span>
        </div>
      </Alert>
    </div>
  );
};

const AlertContainer = ({ notification, matchOnEndpoint, onClick }: any) => {
  switch (notification.type) {
    case "invoices":
      return (
        <Wrapper
          notification={notification}
          matchOnEndpoint={matchOnEndpoint}
          onClick={onClick}
        >
          {notification.message}
        </Wrapper>
      );

    default:
      return (
        <Wrapper
          notification={notification}
          matchOnEndpoint={matchOnEndpoint}
          onClick={onClick}
        >
          {notification.message}
        </Wrapper>
      );
  }
};

export default AlertContainer;
